import {
  Archive,
  BarChart3,
  BookOpenText,
  Boxes,
  BrainCircuit,
  ChevronRight,
  Database,
  FileStack,
  FolderInput,
  Gauge,
  LogOut,
  Menu,
  PanelLeftClose,
  Cpu,
  Scale,
  ScanSearch,
  Settings2,
  X,
} from "lucide-react";
import { useState, type ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { BrandLockup } from "./Brand";

const workNav = [
  { to: "/", label: "投研驾驶舱", icon: Gauge },
  { to: "/fund-research", label: "基金一页纸", icon: ScanSearch },
  { to: "/macro", label: "宏观环境", icon: BarChart3 },
  { to: "/allocation", label: "组合校准", icon: Scale },
  { to: "/committee", label: "投资委员会", icon: BrainCircuit },
  { to: "/one-pager", label: "公司与行业研究", icon: BookOpenText },
  { to: "/materials", label: "内部资料知识库", icon: FolderInput },
  { to: "/memory", label: "投资记忆", icon: Archive },
];

const settingNav = [
  { to: "/model-settings", label: "AI 模型", icon: Cpu },
  { to: "/sources", label: "数据治理", icon: Database },
  { to: "/constraints", label: "机构政策", icon: Settings2 },
  { to: "/templates", label: "研究协议", icon: FileStack },
];

function NavGroup({ title, items, onNavigate }: { title: string; items: typeof workNav; onNavigate: () => void }) {
  return (
    <div className="nav-group">
      <div className="nav-title">{title}</div>
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} end={to === "/"} onClick={onNavigate} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
          <Icon size={16} strokeWidth={1.7} /><span>{label}</span><ChevronRight className="nav-arrow" size={14} />
        </NavLink>
      ))}
    </div>
  );
}

export function Shell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const active = [...workNav, ...settingNav].find((item) => item.to === location.pathname)?.label ?? "智能投研系统";

  return (
    <div className="app-shell">
      <button className="mobile-menu" aria-label="打开导航" onClick={() => setOpen(true)}><Menu size={20} /></button>
      {open && <button className="sidebar-backdrop" aria-label="关闭导航" onClick={() => setOpen(false)} />}
      <aside className={open ? "sidebar open" : "sidebar"}>
        <div className="brand-row">
          <BrandLockup />
          <button className="sidebar-close" aria-label="关闭导航" onClick={() => setOpen(false)}><X size={18} /></button>
        </div>
        <div className="brand-rule" />
        <NavGroup title="工作空间" items={workNav} onNavigate={() => setOpen(false)} />
        <div className="nav-divider" />
        <NavGroup title="数据与设置" items={settingNav} onNavigate={() => setOpen(false)} />
        <div className="sidebar-spacer" />
        <div className="profile">
          <div className="avatar">管</div>
          <div><strong>{user?.username}</strong><span>{user?.role}</span></div>
          <button title="退出登录" onClick={() => void logout()}><LogOut size={16} /></button>
        </div>
      </aside>
      <main className="main-area">
        <header className="topbar">
          <div className="breadcrumb"><PanelLeftClose size={15} /><span>{active}</span></div>
          <div className="topbar-right"><span className="market-dot" />公开数据<span className="sync">各模块独立标注更新时间</span></div>
        </header>
        <div className="content">{children}</div>
        <footer><span>WYX · AlphaOS 智能投研系统</span>公开数据、研究初稿与 AI 输出仅作为研究参考，不构成投资建议 · 投资经理最终确认</footer>
      </main>
    </div>
  );
}
